// VAPID public key (base64-url). Generated once with `npx web-push generate-vapid-keys`.
// The private key half lives only in Supabase secrets (consumed by the
// send-notifications edge function); the public half is safe to embed in
// the client bundle.
export const VAPID_PUBLIC_KEY =
  "BEPkRa8yHDthI34Xr7BEYjgVENSFaUhCztEjf_IE4IomcT9zvTrtcwDvrmJTVwC01gLuGJa6sfgP8xtvcaQEOvQ";
